import { render, staticRenderFns } from "./ErrorBox.vue?vue&type=template&id=6f8011ad&scoped=true"
import script from "./ErrorBox.vue?vue&type=script&lang=js"
export * from "./ErrorBox.vue?vue&type=script&lang=js"
import style0 from "./ErrorBox.vue?vue&type=style&index=0&id=6f8011ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8011ad",
  null
  
)

export default component.exports